import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import { IDENTITY_PROVIDERS } from 'common/constants/constants';
import useSettingsService from 'components/hooks/useSettingsService';
import { useSelector } from 'react-redux';
import { isTeamLicenseSelector } from 'state/selectors/license';

const ALWAYS_TRUE = 'ALWAYS_TRUE';

const mapProviderToAutoRepoDiscoveryFF = {
  [IDENTITY_PROVIDERS.GITHUB]: ALWAYS_TRUE,
  [IDENTITY_PROVIDERS.GITLAB]:
    FEATURE_FLAGS_NAMES.gitlabAutoRepoDiscoveryEnabled,
  [IDENTITY_PROVIDERS.BITBUCKET]:
    FEATURE_FLAGS_NAMES.bitbucketAutoRepoDiscoveryEnabled,
  [IDENTITY_PROVIDERS.AZURE_DEVOPS]:
    FEATURE_FLAGS_NAMES.azureDevopsAutoRepoDiscoveryEnabled
};

const useAutoRepoDiscoveryFF = sensorName => {
  const { getSettingOrDefinitionValue } = useSettingsService();
  const ffName = mapProviderToAutoRepoDiscoveryFF[sensorName];
  const isTeamLicense = useSelector(isTeamLicenseSelector);

  if (isTeamLicense) {
    return false;
  }

  if (ffName === ALWAYS_TRUE) {
    return true;
  }

  const ffValue = getSettingOrDefinitionValue({
    name: ffName
  });

  return !!ffValue;
};

export default useAutoRepoDiscoveryFF;
